<div class="agenda__heading text-center">
  <strong>
    {{ 'holidayList.agenda' | portalTranslate }}
  </strong>
</div>

<ul class="agenda__list">
  @for (event of events; track event) {
    <li
      class="agenda__item"
      [class]="{
        'agenda__item--in-past': event.inPast,
        'text-muted': event.excluded,
      }"
    >
      <!-- Indicator -->
      <!-- Default indicator -->
      @if (!event.excluded && !event.inherited) {
        <span
          class="agenda__indicator agenda__indicator--default"
          [portalTippy]="'holiday.type.default' | translate"
        ></span>
      }
      <!-- Excluded indicator -->
      @if (event.excluded) {
        <span
          class="agenda__indicator agenda__indicator--excluded"
          [portalTippy]="'holiday.type.excluded' | translate"
        ></span>
      }
      <!-- Inherited indicator -->
      @if (event.inherited && !event.excluded) {
        <span
          class="agenda__indicator agenda__indicator--inherited"
          [portalTippy]="'holiday.type.inherited' | translate"
        ></span>
      }
      <!-- Date -->
      <span
        class="agenda__date"
        [class.agenda__date--excluded]="event.excluded"
        [class.agenda__date--inherited]="event.inherited"
      >
        <span class="agenda__day">
          {{ event.date | portalDate: 'dd' }}
        </span>
        <span class="agenda__month">
          {{ event.date | portalDate: 'MMM yy' }}
        </span>
      </span>
      <!-- Title -->
      @if (event.inherited === false) {
        <button class="agenda__title btn btn--portal-link text-truncate" (click)="edit(event)">
          {{ event.title }}
        </button>
      } @else {
        <span class="agenda__title text-truncate">{{ event.title }}</span>
      }
      <!-- Actions -->
      <div class="agenda__actions">
        <ng-container *ngTemplateOutlet="actions; context: { $implicit: event }"></ng-container>
      </div>
    </li>
  }
  <li class="agenda__item agenda__item--new-entry">
    <span (click)="create()" role="button">
      <i class="agenda__new-icon far fa-plus-circle"></i>
      <span class="agenda__new-entry">
        {{ 'holiday.addDialog.title' | translate }}
      </span>
    </span>
  </li>
</ul>
